import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { combineLatest, from, Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { UserDataService } from 'src/app/services/user-data/user-data.service';
import { catchError, concatMap, timeout } from 'rxjs/operators';
import { ErrorHandlingService } from '../services/error-handling/error-handling.service';

@Injectable({
    providedIn: 'root'
})
export class GatewayApiInterceptor implements HttpInterceptor {

    constructor(private userData: UserDataService,
        private errorHandlingService: ErrorHandlingService) { }

    intercept(req: HttpRequest<any>, next: HttpHandler):
        Observable<HttpEvent<any>> {

        var getUrl = from(this.userData.getGatewayUrl());
        var getApiKey = from(this.userData.getApiKey());

        return combineLatest([getUrl, getApiKey]).pipe(
            concatMap(results => {

                let gatewayUrl = results[0];
                let apiKey = results[1];

                let finalUrl = null;

                const isFullUrl = req.headers.get('isFullUrl') || 'false';
                if (isFullUrl === 'true') {
                  finalUrl = req.url;
                }
                else {
                  // If the gateway URL was not set then do not modify the original request URL
                  finalUrl = gatewayUrl != null ? `${gatewayUrl}${req.url}` : req.url;
                }

                // If the API Key is not present then send 'Basic none' as the Authorization header value
                let authBasicValue = apiKey != null ? `Basic ${apiKey}` : 'Basic none';

                // If the original request includes a 'timeout' header then use the value from that header as the request timeout,
                // if not then use the default timeout value from the environment object.
                const timeoutValue = req.headers.get('timeout') || environment.DEFAULT_HTTP_REQUEST_TIMEOUT;
                const timeoutValueNumeric = Number(timeoutValue);

                const platform = this.userData.getPlatform();

                // Create a clone of the request with the new URL and the required headers.
                // While cloning the original headers remove the custom 'timeout' header.
                const authReq = req.clone({
                    url: finalUrl,
                    headers: req.headers.delete('timeout')
                        .delete('isFullUrl')
                        .set('AppVersion', environment.APP_VERSION)
                        .set('Platform', platform)
                        .set('Authorization', authBasicValue)
                });

                return next.handle(authReq).pipe(
                    timeout(timeoutValueNumeric),
                    catchError(error => {
                        this.errorHandlingService.handleError(error);
                        throw error;
                    })
                );
            }));
    }
}
